<template>
    <div class="p-4 bg-white dark:bg-gray-800 rounded-lg">

        <div v-if="notifications.length > 0" class="space-y-4">
            <DashboardMessageNotification
                v-for="notification in notifications"
                :key="notification.id"
                :notification="notification"
            />
        </div>

        <p v-else class="text-gray-500 dark:text-gray-400 text-sm">No note/event available.</p>
    </div>
</template>

<script>
import DashboardMessageNotification from './DashboardMessageNotification.vue'

export default {
    components: { DashboardMessageNotification },
    props: {
        notifications: {
            type: Array,
            required: true,
        },
    },
}
</script>
